import React from "react";
import PageHeader from "../../pageHeader";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaReact } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import { IoLogoCss3 } from "react-icons/io";
import { FaHtml5 } from "react-icons/fa";
import { SiRedux } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { Animate } from "react-simple-animate";
import "./styles.scss";

const About = () => {
  const jobSummery =
    "I have knowledge about 1. HTML, 2. CSS, 3. JavaScript, and 4. React to build all aspects of the UX and UI client landing page. Specializes in using CSS framework Bootstrap, Tailwind CSS, Tailwind CSS component library to build awesome E-commerce sites.";
  const personalData = [
    {
      label: "Name",
      value: "Uhai Mong",
    },
    {
      label: "Age",
      value: "23",
    },
    {
      label: "Address",
      value: "Bangladesh",
    },
    {
      label: "Email",
      value: "uhaimarma2016@gmail.com",
    },
    {
      label: "Phone",
      value: "+8801516341885",
    },
  ];
  return (
    <section id="about" className="about">
      <PageHeader headerText="About Me" icon={<BsInfoCircleFill size={40} />} />
      <div className="about__content">
        <div className="about__content__personalWrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(-1000px)",
            }}
            end={{
              transform: "translateX(0px)",
            }}
          >
            <h3>Front End Developer</h3>
            <p>{jobSummery}</p>
          </Animate>

          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(550px)",
            }}
            end={{
              transform: "translateX(0px)",
            }}
          >
            <h3 className="personalInfoHeader">Personal Information</h3>
            <ul>
              {personalData.map((data, i) => (
                <li key={i}>
                  <span className="label">{data.label}</span>
                  <span className="value">
                    {":"} {data.value}
                  </span>
                </li>
              ))}
            </ul>
          </Animate>
        </div>
        <div className="about__content__servicesWrapper">
                    <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(650px)",
            }}
            end={{
              transform: "translateX(0px)",
            }}
          >
          <div className="about__content__servicesWrapper__innerContainer">
            <div>
              <FaReact size={60} color="var(--primary-color)" />
            </div>
            <div>
              <SiMongodb size={60} color="var(--primary-color)" />
            </div>
            <div>
              <IoLogoCss3 size={60} color="var(--primary-color)" />
            </div>
            <div>
              <FaHtml5 size={60} color="var(--primary-color)" />
            </div>
            <div>
              <SiRedux size={60} color="var(--primary-color)" />
            </div>
            <div>
              <FaNodeJs size={60} color="var(--primary-color)" />
            </div>
            </div>
            </Animate>
        </div>
      </div>
    </section>
  );
};

export default About;
